import { applyWSTheme } from "@wingspanhq/fe-component-library";
import { useEffect, useState } from "react";
import { useQueryCustomization } from "../../query/customization/queries/useQueryCustomization";
import "./styles.scss";

export const useInitCustomization = (params: {
  isSessionSettled: boolean;
  personId?: string;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const isReadyToFetch = !!params.personId;
  const isSessionFetched = params.isSessionSettled;

  const queryCustomization = useQueryCustomization({
    enabled: isReadyToFetch,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onSuccess(data) {
      if (data.support?.portal?.generalUrl) {
        window.document.body.setAttribute("data-no-intercom", "true");
      }
      if (data.appearance) {
        applyWSTheme(data.appearance);
      }
    }
  });

  const isCustomizationFetched = queryCustomization.isFetched;

  useEffect(() => {
    if (isSessionFetched && isReadyToFetch && isCustomizationFetched) {
      setIsLoading(false);
    } else if (isSessionFetched && !isReadyToFetch) {
      setIsLoading(false);
    }
  }, [isSessionFetched, isCustomizationFetched, isReadyToFetch]);

  return {
    isLoading: isLoading
  };
};
